<div class="header__mobile-menu">
  <button class="mobile-menu-toggle" aria-label="Open mobile menu" (click)="toggleMobileMenu()">
    <span class="mobile-menu-toggle__icon"></span>
  </button>
</div>